'use strict';

import api from '@/assets/js/api/index';

export default {
    getMerchantData(payload) {
        let { to, config, hasCancel } = payload || {};
        return new Promise((resolve, reject) => {
            api.get({ url: `${to || ''}`, config, hasCancel })
                .then((response) => {
                    // console.log(response);
                    resolve(response.data);
                })
                .catch((error) => {
                    // console.log(error);
                    reject(error);
                });
        });
    },
    bulkPostData(payload) {
        let { to, data, config, hasCancel } = payload || {};
        return new Promise((resolve, reject) => {
            api.post({ url: `${to || ''}`, data, config, hasCancel })
                .then((response) => {
                    // console.log(response);
                    if (config && config.addHeader) {
                        resolve(response);
                    }

                    resolve(response.data);
                })
                .catch((error) => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};
